import { Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Variant } from '@material-ui/core/styles/createTypography';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { PropAlignment } from '../../types/materialUi';

interface Props {
	title: string;
	titleVariant?: Variant;
	subtitle?: string;
	align?: PropAlignment;
	marginTop?: number;
	marginBottom?: number;
}

const useStyles = makeStyles((theme: Theme) => ({
	pageTitleWrapper: (props: Props) => ({
		marginTop: theme.spacing(props.marginTop ?? 0),
		marginBottom: theme.spacing(props.marginBottom ?? 3),
	}),
}));

export const PageTitle: FunctionComponent<Props> = (props) => {
	const { t } = useTranslation();
	const classes = useStyles(props);

	return (
		<div className={`page_title ${classes.pageTitleWrapper}`}>
			<Typography
				variant={props.titleVariant || 'h2'}
				align={props.align}
				className="page_title_main"
			>
				{t(props.title)}
			</Typography>
			{props.subtitle && (
				<Typography variant="subtitle1" align={props.align}>
					{t(props.subtitle)}
				</Typography>
			)}
		</div>
	);
};
